import {
  Typography,
} from '@mui/material';
import React from 'react';
import TabsLayout from '../../common/tabs-layout/tabs-layout';
import WebhooksDashboard from './webhooks/dashboard';
import APIKeysDashboard from './api-keys/dashboard';
import ShopifyDashboard from './shopify/shopify_dashboard';
import { isMobile } from 'react-device-detect';
import ApiIcon from '@mui/icons-material/Api';
import { WebhookIcon } from 'lucide-react';
import { FaShopify  } from 'react-icons/fa';
import {SiWoocommerce} from 'react-icons/si';
import WoocommerceDashboard from './woocommerce/woocommerce_dashboard';
import WooCommerceIcon from '../../common/woocommerce/icon';


function APIIntegrations() {
  return (
    <>
      <Typography
        variant="h3"
        component="h3"
        sx={{ textAlign: 'center', mt: 1 }}
      >
        API Integrations
      </Typography>

      <TabsLayout
        source={"api-integrations-layout"}
        orientation={"horizontal" }
        sections={[
          {
            label: 'API Keys',
            icon: <ApiIcon fontSize={"medium"} />,
            content: <APIKeysDashboard />,
          },
          {
            label: 'Shopify',
            content:<ShopifyDashboard />,
            icon: <FaShopify fontSize={28} />,
          },
          {
            label: 'Commerce',
            content:<WoocommerceDashboard />,
            icon: <WooCommerceIcon />,
          },
          {
            label: 'Webhooks',
            icon: <WebhookIcon fontSize={"medium"} />,
            content: <WebhooksDashboard />,
          },
        ]}
      />
    </>
  );
}

export default APIIntegrations;
